export default __webpack_public_path__ + "static/media/save-money.bc374024.png";